import moment from "moment";
import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { combineData, lorem } from "../../utils";
import { default as defaultData } from "./data.json";
import { style } from "./style";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";
import { FooterLayouts } from "../types";
import {
  LinkDisplayTypes,
  LinkLayoutStyles,
} from "@/Apps/Pages/WebComponents/v2/Navigation/types";
import { ButtonPresets } from "@/Apps/Pages/WebComponents/v2/Button/types";


const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: FooterLayouts.ONE,
  layout: FooterLayouts.ONE,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/footers/Footer01.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkzoubo42irl0780q5gtpfk3",
    itemId: "p3erxe2tw",
  },
  default: {
    type: ComponentTypes.SECTION,
    label: PageSectionCategory.FOOTER,
    bodyOnly: true,
    canHaveChildren: false,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((3 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.TEXT,
                canHaveChildren: false,
                properties: {
                  ...style.TEXT,
                  ...get(content, "sub_headline.style", {}),
                },
                html: `© ${moment().format("YYYY")} All Rights Reserved`,
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((9 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.NAVIGATION,
                canHaveChildren: false,
                linkStyle: style.NAVIGATION.linkStyle,
                layoutStyle: LinkLayoutStyles.HORIZONTAL,
                properties: {
                  padding: 20,
                  display: "inline-block",
                  textAlign: "right",
                },
                data: [
                  {
                    id: uniqueId(),
                    caption: "Home",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "FAQs",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "About Us",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Contact Us",
                    linkDisplayType: LinkDisplayTypes.TEXT,
                  },
                  {
                    id: uniqueId(),
                    caption: "Getting Started",
                    preset: ButtonPresets.BUTTON01,
                    linkDisplayType: LinkDisplayTypes.BUTTON,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
